import { render, staticRenderFns } from "./EditTextType.vue?vue&type=template&id=8f969a44&"
import script from "./EditTextType.vue?vue&type=script&lang=js&"
export * from "./EditTextType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports